export default {
  myFiles: 'Моји документи',
  newDocument: 'Нови документ',
  messages: 'Поруке',
  addresses: 'Адресе',
  newAddress: '+ Нова адреса',
  aboutUs: 'О нама',
  addArticle: 'Додај артикал',
  addAttribute: 'Додај атрибут',
  addBank: 'Додај банку',
  addBlog: 'Додај новости',
  addBrand: 'Додај бренд',
  addCategory: 'Додај категорију',
  addCompany: 'Додај компанију',
  addCountry: 'Додај државу',
  addCurrency: 'Додај валуту',
  addCustomerBankAccount: 'Додај кориснички рачун',
  accountDetails: 'Детаљи о профилу',
  addExpressPost: 'Додај брзу пошту',
  addInterestsArea: 'Додај дјелатност',
  addMeasurementUnit: 'Додај јединицу мере',
  addPoll: 'Додај анкету',
  addProductSale: 'Додај акцију',
  areYourSureEmptyShoppingCart: 'Да ли сте сигурни да желите испразнити кошарицу?',
  addTab: 'Додај таб',
  blog: 'Блог',
  addTown: 'Додај град',
  addToCart: 'Додај у корпу',
  addToCart2: 'У кошарицу',
  docDate: 'Датум док',
  account: 'Конто',
  owes: 'Дугује',
  comment: 'Коментар',
  accountNumber: 'Број рачуна',
  claims: 'Потражује',
  paymentTerm: 'Рок плаћања',
  bookingDateShort: 'Датум књ',
  addUser: 'Додај корисника',
  addVariation: 'Додај варијацију',
  apply: 'Примени',
  article: 'Производ',
  areYouSureArticle: 'Јесте ли сигурни да желите избрисати артикал {article}?',
  areYouSureAttribute: 'Јесте ли сигурни да желите избрисати атрибут {attribute}?',
  areYouSureAttributeArticle: 'Јесте ли сигурни да желите избрисати атрибут?',
  areYouSureAttributeValue:
    'Јесте ли сигурни да желите избрисати {attributeValue} вредност атрибута?',
  areYouSureBank: 'Јесте ли сигурни да желите избрисати банку {bank}?',
  areYouSureBlog: 'Јесте ли сигурни да желите избрисати новости {blog}?',
  areYouSureBrand: 'Јесте ли сигурни да желите избрисати бренд {brand}?',
  areYouSureCategory: 'Јесте ли сигурни да желите избрисати категорију {category}?',
  areYouSureCompany: 'Јесте ли сигурни да желите избрисати компанију {company}?',
  areYouSureCountry: 'Јесте ли сигурни да желите избрисати државу {country}?',
  areYouSureCurrency: 'Јесте ли сигурни да желите избрисати валуту {currency}?',
  areYouSureCustomerBankAccount:
    'Јесте ли сигурни да желите избрисати кориснички банковни рачун {bankAccount}?',
  areYouSureExpressPost: 'Јесте ли сигурни да желите избрисати брзу пошту {post}?',
  areYouSureInterestsArea: 'Јесте ли сигурни да желите избрисати дјелатност {area}?',
  areYouSureProductSale: 'Јесте ли сигурни да желите избрисати акцију {productSale}?',
  areYouSureSelected: 'Јесте ли сигурни да желите избрисати одабране записе?',
  areYouSureTab: 'Јесте ли сигурни да желите избрисати таб {tab}?',
  areYouSureTown: 'Јесте ли сигурни да желите избрисати град {town}?',
  areYouSureUser: 'Јесте ли сигурни да желите избрисати корисника {user}?',
  areYouSureCancelOrder: 'Да ли сте сигурни да желите отказати наруџбу?',
  areYouSureApproveOrder: 'Да ли сте сигурни да желите одобрити наруџбу?',
  areYouSureDeleteShoppingCart: 'Да ли сте сигурни да желите избрисати корпу?',
  shoppingCartNotConcluded: 'Тренутно имате незакључену корпу.',
  shoppingCartItemsReplacement: 'Ставке у корпи ће бити замењене ставкама из сачуване корпе.',
  doYouWantToContinue: 'Желите ли наставити?',
  thereAreCurrentlyNoSavedShoppingCarts: 'Тренутно нема сачуваних корпи.',
  articleDetails: 'Детаљи артикла',
  articleDetailsInfo: 'Унесите детаље артикла',
  articles: 'Артикли',
  attributes: 'Атрибути',
  banks: 'Банке',
  blogs: 'Новости',
  brands: 'Брендови',
  brand: 'Бренд',
  service: 'Сервис',
  cancel: 'Откажи',
  newRequest: 'Нови захтев',
  contactPerson: 'Контакт особа',
  categories: 'Категорије',
  category: 'Категорија',
  serialNumber: 'Серијски број',
  productCode: 'Шифра производа',
  checkout: 'Наплата',
  download: 'Преузми',
  actions: 'Акције',
  sales: 'Акције',
  folderIsEmpty: 'Ваша мапа са документима је празна',
  physicalPersons: 'Физичка лица',
  goToCheckout: 'Иди на наплату',
  choose: 'Изаберите',
  chooseOptions: 'Изаберите опције',
  contact: 'Контакт',
  onlineShopping: 'Онлајн куповина',
  ord: 'Рбр',
  myAccount2: 'Мој налог',
  myArticles: 'Моји производи',
  followUsOnSocialMedia: 'Пратите нас на друштвеним мрежама',
  deliveryAndPayment: 'Достава и плаћање',
  complaintsAndReturns: 'Рекламација и поврати',
  securityAndPrivacy: 'Сигурност и приватност',
  termsOfService: 'Услови коришћења и куповине',
  youNeedHelp: 'Треба вам помоћ?',
  from: 'Од',
  to: 'До',
  title: 'Наслов',
  markAllAsRead: 'Означи све као прочитано',
  faq: 'Честа питања',
  howToRegister: 'Како се регистровати?',
  shoppingHelp: 'Помоћ при куповини',
  bonusProgramRules: 'Правила Бонус програма',
  comingSoon: 'Ускоро',
  companies: 'Компаније',
  countries: 'Државе',
  countryDetails: 'Детаљи државе',
  countryDetailsInfo: 'Унесите детаље државе',
  viewFinances: 'Погледај финансије',
  coupons: 'Купони',
  currencies: 'Валуте',
  customerBankAccounts: 'Кориснички рачуни',
  profileDashboard: 'Дашборд',
  defaultAddress: 'Следеће адресе ће се према задавним подешавањима користити на страници за наплату.',
  delete: 'Избриши',
  currentDebt: 'Тренутно задужење',
  deleteArticle: 'Избриши артикал',
  paymentTerms: 'Услови плаћања',
  deleteAttribute: 'Избриши атрибут',
  debtOutsideCurrency: 'Дуг ван валуте',
  deleteBank: 'Избриши банку',
  deleteBlog: 'Избриши новости',
  edit: 'Измени',
  approvedDebt: 'Одобрено задужење',
  deleteBrand: 'Избриши бренд',
  deleteCategory: 'Избриши категорију',
  notSetAnyAddressYet: 'Још нисте поставили ниједну адресу.',
  deleteCompany: 'Избриши компанију',
  deleteCountry: 'Избриши државу',
  deleteCurrency: 'Избриши валуту',
  deleteCustomerBankAccount: 'Избриши кориснички банковни рачун',
  deleteExpressPost: 'Избриши брзу пошту',
  deleteInterestsArea: 'Избриши дјелатност',
  deleteProductSale: 'Избриши акцију',
  deleteSelected: 'Избриши одабрано',
  deleteTab: 'Избриши таб',
  deleteTown: 'Избриши град',
  deleteUser: 'Избриши корисника',
  deleteVariationImage: 'Јесте ли сигурни да желите избрисати слику варијације?',
  details: 'Детаљи',
  detailsInfo: 'Унесите детаље',
  editArticle: 'Ажурирај артикал',
  editAttribute: 'Ажурирај атрибут',
  editBank: 'Ажурирај банку',
  editBlog: 'Ажурирај новости',
  editBrand: 'Ажурирај бренд',
  editCategory: 'Ажурирај категорију',
  editCompany: 'Ажурирај компанију',
  editCountry: 'Ажурирај државу',
  editCurrency: 'Ажурирај валуту',
  editCustomerBankAccount: 'Ажурирај кориснички рачун',
  editExpressPost: 'Ажурирај брзу пошту',
  editInterestArea: 'Ажурирај дјелатност',
  editPoll: 'Ажурирај анкету',
  editProductSale: 'Ажурирај акцију',
  editTab: 'Ажурирај таб',
  editTown: 'Ажурирај град',
  editUser: 'Ажурирај корисника',
  expressPosts: 'Брзе поште',
  forgotPassword: 'Заборављена лозинка',
  greetings: 'Здраво',
  homePageTitle: 'Почетна',
  highlightedCategories: 'Издвојено',
  import: 'Импортуј',
  importArticles: 'Импортуј артикле',
  interestsAreas: 'Дјелатности',
  cancel2: 'ОДУСТАНИ',
  cancel3: 'Одстани',
  login: 'Пријава',
  logIn: 'Пријави се',
  logout: 'Одјава',
  measurementUnits: 'Јединице мере',
  myAccount: 'Мој профил',
  delete2: 'ИЗБРИШИ',
  myProfile: 'Профил',
  news: 'Вести',
  newArticles: 'Нови производи',
  no: 'Не',
  attention: 'Пажња',
  warning: 'Упозорење',
  areYouSureYouWantToDeleteAcc: 'Да ли сигурно желите избрисати ваш рачун? Унесите лозинку да бисте избрисали ваш рачун.',
  areYouSureYouWantToDeleteAddress: 'Јесте ли сигурни да желите уклонити одабрану адресу?',
  noItemSelected: 'Нема одабраних записа',
  noRecords: 'Нема резултата према траженим параметрима',
  notFound: 'Тражена страница није пронађена',
  orderArticles: 'Артикли у кошарици',
  orders: 'Наруџбе',
  polls: 'Анкете',
  priceRange: 'Ценовни ранг',
  productSales: 'Акције',
  recentlyViewdItems: 'Раније сте гледали',
  register: 'Регистрација',
  resetFilters: 'Поништи филтере',
  rma: 'Пријављене неправилности (РМА)',
  uploadAttachment: 'Приложите слике, датотеке...',
  rmaForm: 'Рекламације',
  save: 'Сачувај',
  saveArticle: 'Сачувај артикал',
  saveCategory: 'Сачувај категорију',
  saveCountry: 'Сачувај државу',
  search: 'Претрага',
  find: 'Унесите минимално 3 карактера...',
  selectAction: 'Изаберите акцију',
  shoppingCart: 'Корпа',
  tabs: 'Табови',
  terms: 'Услови коришћења',
  townDetails: 'Детаљи града',
  townDetailsInfo: 'Унесите детаље града',
  towns: 'Градови',
  total: 'Укупно',
  amount: 'Износ',
  topBrands: 'Топ брендови',
  userProfile: 'Кориснички профил',
  users: 'Корисници',
  userArticles: 'Производи одабрани за вас',
  viewAll: 'Види све',
  viewAllFrom: 'Види све из',
  addToCartSuccessMessage: 'Управо сте додали артикал у <br/> кошарицу: ',
  continueShopping: 'Настави куповину',
  clearShoppingCart: 'Испразни кошарицу',
  updateShoppingCart: 'Ажурирај кошарицу',
  goToShoppingCart: 'Иди у кошарицу',
  wishlist: 'Листа жеља',
  addToWishlist: 'Додај у листу жеља',
  yes: 'Да',
  reviews: 'Рецензија',
  tabReviews: 'Рецензије',
  writeReview: 'Унесите вашу рецензију',
  submitReview: 'Пошаљи рецензију',
  anonymous: 'Анонимно',
  linkedArticles: 'Повезани производи',
  quickPreview: 'Брзи преглед',
  loginRegisterTitle: 'Пријава / Креирање рачуна',
  loginTitle: 'Пријава',
  loginSubTitle: 'Уколико имате кориснички рачун пријавите се.',
  loginButton: 'ПРИЈАВА',
  registerTitle: 'Затражите кориснички рачун',
  registerSubTitle: 'Попуните тражене информације и наш тим ће вас контактирати у најкраћем року, те ћемо вам израдити кориснички рачун. Хвала!',
  chooseCountry: 'Изаберите државу',
  chooseTown: 'Изаберите град',
  registerSectionLoginDataTitle: 'Подаци за пријаву',
  acceptTerms: 'Прихватам услове коришћења',
  registerSubmit: 'Затражи рачун',
  repeatOrder: 'Понови наруџбу',
  close: 'Затвори',
  defaultSort: 'Задано сортирање',
  sortByRating: 'Сортирај по оцени',
  sortByDateOldest: 'Сортирај по датуму објаве: старије према новом',
  sortByDateNewest: 'Сортирај по датуму објаве: ново према старијем',
  sortByPriceLow: 'Сортирај по цени: нижа према вишој',
  sortByPriceHigh: 'Сортирај по цени: виша према нижој',
  pagingResults: 'Приказује се {fromResults} - {toResults} од {totalItems} резултата',
  showMore: 'Прикажи више',
  productIsAvalible: 'Производ је доступан',
  productIsAvalibleToOrder: 'Производ је доступан по наруџби',
  deliveryTimeDays: 'Време испоруке је {days} дана од наруџбе производа',
  itemIsAvalibleContactRepresentative: 'Артикал је доступан по наруџби. Молимо контактирајте вашег продајног представника.',
  availableOnRequest: 'Доступно на упит',
  requestPresentation: 'Затражи презентацију',
  howDoYouRateThisProduct: 'Како оцењујете овај производ?',
  administrator: 'Администратор',
  passwordRecovery: 'Опоравак лозинке',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Унесите вашу е-маил адресу испод и послаћемо вам упутства за ресетовање!',
  reset: 'Ресетуј',
  remembered: 'Запамћено',
  finances: 'Финансије',
  allRightsReserved: 'Сва права задржана',
  updateAddress: 'Ажурирај адресу',
  state: 'Држава',
  chooseState: 'Изаберите државу',
  listIsEmpty: 'Листа је празна',
  noResultsAccordingToTheGivenParameters: 'Нема резултата према задавним параметрима',
  termsOfUseIsMandatory: 'Поље Услови коришћења је обавезно',
  resetPassword: 'Ресет лозинке',
  accVerificationInProgress: 'Верификација рачуна у току',
  accVerification: 'Верификација рачуна',
  verificationLinkHasExpired: 'Верификациони линк је истекао. Молимо контактирајте наше администраторе: support@eurosan.ba или +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Управо сте додали артикал у кошарицу:',
  manufacturer: 'Произвођач',
  productName: 'Назив производа',
  shoppingCarts: 'Кошарице',
  preview: 'Преглед',
  documentName: 'Назив документа',
  status: 'Статус',
  orderNumber: 'Број наруџбе',
  orderer: 'Наруџилац',
  date: 'Датум',
  document: 'Документ',
  delivery: 'Достава',
  deliverTo: 'Доставити на',
  discount: 'Рабат',
  savingsByUsingPromoCode: 'Уштеда коришћењем промо кода',
  itemAddedToCart: 'Артикал додан у кошарицу.',
  articlesOnSale: 'Артикли на акцији',
  controlPanel: 'Контролна табла',
  tags: 'Тагови',
  totalAmountWithDelivery: 'Укупно са доставом',
  youHaveNotPlacedAnorderYet: 'Нисте још увек направили наруџбу',
  quantity: 'Количина',
  amountWithoutVat: 'Износ без ПДВ-а',
  vatAmount: 'Износ ПДВ-а',
  orderNo: 'Наруџба бр',
  days: 'дана',
  time: 'Време',
  quantity2: 'КОЛИЧИНА',
  rejectOrd: 'Одбиј нар',
  approveOrd: 'Одобри нар',
  wishListIsEmpty: 'Листа жеља празна',
  sale: 'АКЦИЈА',
  totalWithoutTax: 'Укупно без пореза',
  sendRequest: 'ПОШАЉИ ЗАХТЕВ',
  promoCode: 'Промо код',
  send: 'Пошаљи',
  registrationCode: 'Шифра пријаве',
  created: 'Креирано',
  giftCard: 'Поклон код',
  changePassword: 'Промена лозинке',
  emailAddress: 'Емаил адреса',
  oldPassword: 'Стара лозинка',
  deleteUserAcc: 'ИЗБРИШИ КОРИСНИЧКИ РАЧУН',
  permanentlyDeletedAcc: 'Кориснички рачун ће бити трајно обрисан',
  confirmNewPassword: 'Потврдите нову лозинку',
  passwordConfirmation: 'Потврда лозинке',
  newPassword: 'Нова лозинка',
  newPassLeaveBlank: 'Нова лозинка (оставите празно уколико не желите мењати)',
  currentPassLeaveBlank: 'Тренутна лозинка (оставите празно уколико не желите мењати)',
  areasOfInterest: 'Интересна подручја',
  chooseAreaOfInterest: 'Изаберите интересна подручја',
  totalTax: 'Укупно пореза',
  price: 'Цена',
  price2: 'ЦЕНА',
  newAddress2: 'Нова адреса',
  show: 'Прикажи',
  stock: 'Стање',
  yourTotalDebtIs: 'Ваше укупно задужење износи',
  isInStock: 'Има на стању',
  print: 'Принт',
  signUpForTheNewsletter: 'Пријавите се на њузлетер',
  latestInformations: 'Добите све најновије информације о догађајима, распродајама и понудама.',
  subscribe: 'Претплатите се',
  aboutEurosanGroup: 'О Еуросан групацији',
  responsibleBusiness: 'Одговорно пословање',
  noDataToAccordingData: 'Нема података према траженим параметрима',
  jobAtEurosan: 'Посао у Еуросану',
  vpc: 'ВПЦ',
  products: 'производа',
  phoneNumber: 'Број телефона',
  tax: 'ПДВ',
  defaultAddress2: 'Задата адреса',
  totalWithVat: 'Укупно са ПДВ',
  totalWithoutVat2: 'Укупно без ПДВ',
  summary: 'Сажетак',
  warranty: 'Гаранција',
  zipCode: 'Зип код',
  indeterminate: 'Неодређено',
  description: 'Опис',
  completeSolutionsForYourBusiness: 'Комплетна рјешења за успех Вашег пословања',
  whoAreWe: 'КО СМО МИ',
  about: {
    aboutEurosan: 'Eurosan Ecotime групација настала је 1998. године инспирисана жељом за здравијим и срећнијим радним просторима. Наш; циљ је јасан: бити Ваш; поуздан партнер у одржавању чистоће, хигијене и сигурности. Верујемо да чисто и сигурно радно окружење покреће успех.',
    aboutEurosan2: '"Здравије, сигурније, продуктивније" - то је наше обећање Вама!',
    aboutEurosan3: 'Кроз наш;e свеобухватне услуге и производе -; од професионалног чиш;ћења до еколош;ки прихватљивих производа и заш;tитне опреме -; ми стварамо просторе у којима људи диш;у лакш;e, раде ефикасније и живе здравије.',
    aboutEurosan4: 'Одлучите се за нас и придружите нам се у стварању здравије и сигурније будућности.',
    ourMission: 'НАША МИСИЈА',
    mission: 'Бити ваш поуздани партнер у стварању чистог, сигурног и одрживог окружења кроз прилагођена решења и изузетну услугу.',
    ourVision: 'НАША ВИЗИЈА',
    vision: 'Постати лидер у пружању одрживих и прилагођених решења за чистију, здравију и сигурнију будућност, увек стављајући потребе наших клијената на прво место.',
    ourValues: 'НАШЕ ВРЕДНОСТИ',
    values: 'Наше темељне вредности означавају оно што јесмо, што радимо и начин на који то радимо, а оне су висок квалитет услуга и производа, знање о хигијени и брига о сигурности и здрављу људи.',
    whyChooseUs: 'ЗАШТО НАС ОДАБРАТИ?',
    efficiency: 'УЧИНКОВИТОСТ:',
    efficiencyText: 'Чистите паметније, радите мање.',
    improvedHygiene: 'ПОБОЛЈШАНА ХИЈГИЈЕНА:',
    improvedHygieneText: ' Изванредна разина хигијене за сваки простор.',
    effectiveCleaning: 'ДЈЕЛОТВОРНО ЧИШЋЕЊЕ:',
    effectiveCleaningText: ' Снага чистоће у свакој амбалажи.',
    improvedWorkerSafety: 'ПОБОЉШАНА СИГУРНОСТ РАДНИКА:',
    improvedWorkerSafetyText: ' Заштитите своје раднике врхунском заштитном опремом.',
    improvedDineExperience: 'ПОБОЉШАНО ГАСТРОНОМСКО ИСКУСТВО:',
    improvedDineExperienceText: ' Атмосфера која одише луксузом и квалитетом.',
    greaterGuestSatisfaction: 'ВЕЋЕ ЗАДОВОЉСТВО ГОСТИЈУ:',
    greaterGuestSatisfactionText: ' Еколошки прихватљива хотелска козметика врхунског квалитета.',
    timeSaving: 'УШТЕДА ВРЕМЕНА:',
    timeSavingText: ' Уштедите време и енергију - препустите бригу о чишћењу нама.',
    longerEquipmentLife: 'ДУЖИ ВЕК ТРАЈАЊА ОПРЕМЕ:',
    longerEquipmentLifeText: ' За безбрижност - ваша опрема у сигурним рукама нашег сервиса.',
    atService: 'Поносно смо на услузи више од ',
    threeThousandClients: '3.000 клијената',
    inCountries: 'у БиХ, Србији и Црној Гори',
    yearsOfExistence: 'Година постојања',
    numberOfEmployees: 'Делатника',
    activeArticles: 'Активних артикала',
  },
  recentBlogs: 'Недавне вести',
  readMore: 'Прочитај више',
  searchFor: 'Претрага',
  archive: 'Архива',
  payment: 'Плаћање',
  deliveryAddress: 'Адреса за доставу',
  deliverHere: 'Доставити овде',
  deliveryAddressValidationMessage: 'Молимо Вас да унесете бар једну адресу за доставу пре него што наставите са процесуирањем наруџбе',
  deliveryMethod: 'Начин доставе',
  free: 'Бесплатно',
  deliveryTime: 'Време испоруке 2 до 3 радна дана',
  personalPickup: 'Лично преузимање',
  personalVisitToTheBranch: 'Лични одлазак у пословницу',
  ourDelivery: 'Наша достава',
  deliverySevenDays: 'Време испоруке cca. 7 дана',
  orderAmountFromText: '*Износом наруџбе од ',
  getFreeDeliveryText: ' KM остварујете бесплатну доставу',
  articlesInShoppingCart: ' артикала у кошарици',
  orderTotalAmountWithoutVat: 'Укупно наруџба (без ПДВ): ',
  orderTotalBruttoWeight: 'Укупна килажа ',
  promoCodeDiscount: '*Уштеда приликом коришћења промо кода: ',
  postage: 'Поштarina',
  totalOrderAmountWithPostage: 'Укупно с поштарино: ',
  paymentMethod: 'Наčin плаћања',
  note: 'Напомена',
  acceptTermsOfUse: 'Прихватам услове коришћења',
  back: 'Натраг',
  placeOrder: 'Закључи наруџбу',
  nextStep: 'ДАЛЈЕ',
  complaints: {
    complaints: 'Рекламације',
    privateBuyers: 'За приватне купце:',
    text1: 'Уколико установите, приликом прве употребе (унутар 7 дана од пријема), да је производ који сте добили неисправан, молимо Вас да нас контактирате и следите наведене кораке:',
    text2: 'Пошаљите нам информације са бројем наруџбе, бројем рачуна или вашим корисничким именом и описом рекламације путем',
    emailAddress: ' е-маил адресе ',
    phone: 'или телефоном на ',
    text3: 'Послаћемо Вам потврду пријема рекламације и, на основу Вашег описа рекламације, информацију о томе може ли се производ заменити за нови и може ли се за производ вратити новац.',
    text4: 'У случајевима када се производ може заменити за нови и када се за производ може вратити новац, на Вашу адресу шаљемо доставну службу која прикупља рекламирани производ и враћа на наше складиште. Ваша обавеза је да производ запакујете и спремите за преузимање брзе поште у оригиналној амбалажи са свим додацима и документацијом коју сте добили уз производ. Када производ стигне на складиште, након што буде прегледан, шаљемо Вам обавештење о поврату новца/слању замјенског производа. Поврат новца/замена за нови производ биће одрађена унутар 2-3 дана, а најкасније након 15 дана. У супротном нас контактирајте телефоном на 080 080 080 или е-маилом на webshop@eurosan.ba',
    text5: 'Ако је амбалажа оштећена немојте преузимати производ, већ достављачу скрените пажњу на оштећење амбалаже и затражите да производ врати у Eurosan. Ако купац не рекламира оштећење амбалаже достављачу у тренутку преузимања производа, сматра се да је преузео производ са неоштећеном амбалажом.',
    text6: 'У случају да производ који сте добили не одговара сликом или спецификацијом производу који сте наручили, исти можете заменити или вратити у замену за новац унутар 7 дана од пријема. За остваривање овог права, потребно је неоштећени производ послати у оригиналном паковању са свом опремом и документацијом са којом је производ био оригинално испоручен.',
    businessCustomers: 'За пословне купце: ',
    text7: 'Пословни купци попуњавају образац зван "Рекламације" помоћу којег шаљу рекламације предузећу Eurosan д.о.о. На eurosan.ba веб шопу у одељку "Мој профил" се налази образац који попуњавате на начин да упишете контакт особу, назив и шифру производа, бренд, серијски број, упишете опис, приложите слику, те напишете број рачуна. На крају кликнете пошаљи, а на истом месту можете пратити стање ваше рекламације, да ли је на чекању или завршена. На исти начин можете послати захтев уколико требате сервисирати машину која не ради. У том случају је веома битно послати слике како би Eurosan сервисери могли тачно знати о чему се ради.',
    text8: 'За све додатне информације можете контактирати свог продајног представника, позвати нас на',
    text9: '080 080 080 или послати е-маил на ',
  },
  contactUs: {
    commercialist: 'Комерцијалиста',
    eurosan: 'Eurosan д.о.о.',
    workTimeText: 'Радно време',
    workTime1: 'Понедељак - Петак: 07:30-16:00',
    workTime2: 'Субота (од 6. до 10. месеца): 08:00-12:00',
    address1: 'Бишће поље bb, 88000 Мостар',
    ecotime: 'Ecotime д.о.о.',
    workTime3: 'Понедељак - Петак: 08:00-16:00',
    workTime4: 'Субота: 08:00-12:00',
    address2: 'Лужанско поље 7, 71210 Илиџа',
    eurosanBl: 'Eurosan Бања Лука д.о.о.',
    workTime5: 'Субота: 09:00-13:00',
    address3: 'Јована Бијелића bb, 78000 Бања Лука',
  },
  FAQ: {
    faq: 'Честа питања / FAQ',
    text1: ' Како бисмо олакш;али сналажење на наш;ем веб шопу, одговорили смо на ваш;a најчеш;ћа питања. Верујемо да ће вам одговори помоћи како бисте ш;то лакш;e, брже и без недоумица изврш;или наруџбу жељеног производа.',
    q1: 'Како се регистровати и направити профил?',
    text2: 'Када отворите наш; веб шоп требате затражити кориснички рачун попуњавањем тражених информација. Након тога, наш; тим ће вас контактирати у најкраћем року, те ћемо вам израдити кориснички рачун. Подаци које требате попунити су: име и презиме, компанија, телефон, адреса, држава, град и интересна подручја. Када су у питању интересна подручја, битно је да означите онај сектор којем припадате и којим се бавите, било да су то здравствене установе, угоститељство, теретане, производња или друго понуђено.',
    text3: 'Можете куповати без прављења корисничког рачуна, дакле као гост. Потребно је само да унесете своје податке за доставу, као и емаил како бисмо вам могли послати потврду успеш;не куповине. Пријавити се можете и преко Facebook и Google платформи које су понуђене.',
    q2: 'Како наручити производе?',
    text4: 'Наруџивање је веома једноставно, отворите артикл који желите наручити, кликнете "у кош;арицу", или на брзом прегледнику кликнете одговарајућу иконицу која се налази у десном углу слике. Када заврш;ите са додавањем артикала, отворите корпу и идите на наплату. Изаберите адресу за доставу, начин доставе и начин плаћања. На крају кликнете "закључи наруџбу" и самим тим ваш;a наруџба је послата. На ваш;у емаил адресу стиже потврда о изврш;еној наруџби.',
    text5: 'Отворите артикл који желите наручити и додајте га у кош;арицу. Када заврш;ите са додавањем артикала, отворите корпу и идите на наплату. Испуните податке који се траже од вас, а то су: име и презиме, адреса, е-маил адреса, број телефона и начин плаћања. На крају кликнете "закључи наруџбу" и самим тим ваш;a наруџба је послата. На ваш;у емаил адресу стиже потврда о изврш;еној наруџби.',
    q3: 'Како се врши достава?',
    text6: 'Пословни купци имају више опција доставе, а то су:',
    eurosanFreeDelivery: 'Eurosan бесплатна достава',
    postDelivery: 'достава брзом поš;том (Хрватска поš;та Мостар)',
    text7: 'лично преузимање у градовима Мостар, Сарајево и Бања Лука, односно у фирмама Групе',
    text8: 'Достава се врши брзом поš;том. (Хрватска Поš;та Мостар уз време испоруке од 24h)',
    text9: 'Такође, купци могу лично преузети наруџбу у једној од наш;их пословница у Мостару, Сарајеву или Бања Луци.',
    q4: 'Да ли су ваш;i производи погодни за мале бизнисе?',
    text10: 'Да, наш;i производи су погодни за велике компаније, мале бизнисе и предузећа, као и приватне кориснике и домаћинства.',
    q5: 'Да ли нудите презентације, тренинг или подрш;ку за ваш;e производе?',
    businessCustomers: 'Пословни купци:',
    text11: 'Пословни купци имају опцију презентације производа за одређене производе попут маš;ина за чиш;ћење, одређеног хемијског програма, помагала за чиш;ћење и сл. За сваки купљени производ, купци ће имати тренинг где ће наш;i стручњаци објаснити на који начин користити одређени производ. Такође, на веб шопу у склопу сваког артикла се налази техничка документација и начин кориš;тења производа. Сваки купац има свог продајног представника који му је ту као подрш;ка при кориšтењу производа.',
    text12: 'За све нејасноће, пословни купци увек могу контактирати наш; бесплатни инфо телефон',
    text13: ' 080 080 080 или послати нам е-маил на ',
    privateBuyers: 'Приватни купци:',
    text14: 'Приватни купци нам се путем бесплатног инфо телефона ',
    text15: 'или путем других канала комуникације, увек могу обратити за помоћ, савет и правилан избор производа за њихову потребу у приватне сврхе и домаћинства. Корисничка подршка је увек доступна.',
    q6: 'Које кредитне картице примате?',
    text16: 'Поред плаћања готовином пouteћу, приватни купци имају опцију плаћања и VISA, MasterCard и Maestro картицама.',
    q7: 'Да ли достављате производе ван БиХ?',
    text17: 'Не. Наш;e тржиш;те је локално и обухвата само територију Босне и Херцеговине. Међутим, ту су наш;e две партнерске фирме, Интереста д.о.о. у Црној Гори и Ecotime д.о.о. Београд у Србији. За додатне информације, будите нас слободни контактирати.',
  },
  newsletterConfirm: {
    backToShop: 'Повратак у продавницу',
    great: 'Одлично!',
    subscribed: 'Претплатили сте се на Eurosan Њузлетер',
  },
  passwordResetSuccess: 'Лозинка је успешно обновљена',
  backToLogin: 'Повратак на пријаву',
  addSelected: 'Додај изабране',
  service2: {
    text1: 'Eurosan д.о.о. гарантује да сви производи до рока предаје купцу поседују квалитет и да су исти без недостатака као и да се могу користити у складу са декларисаном наменом, сагласно декларацији произвођача.',
    text2: 'Купац је у обавези да приликом пријема нарученог производа исти прегледа и утврди да ли има недостатака. Уколико се недостаци утврде, исти ће бити отклоњени у гарантном року.',
    text3: ' Дужина гарантног рока је наведена у гарантном листу, уколико производ поседује исти.',
    text4: ' У случају да је производ испоручен са недостатком, купац има право на замену истог.',
    text5: 'Од рекламација су изузети недостаци који су проузроковани неспретним руковањем и супротно упутству произвођача за руковање производима.',
    text6: 'Рекламације производа се признају уз приложени фискални рачун и исправно попуњен гарантни лист као доказ куповине. У случају рекламације производа, информације о начину пријаве квара или слању овлашћеном сервису потражите на гарантном листу испорученом уз производ или нас ',
    text7: ' контактирајте на контакт телефон 080 080 080 или путем емаил адресе ',
    text8: 'За поправку производа испоручених од стране Eurosan д.о.о. обезбедили смо квалитетну услугу како у гарантном периоду тако и ван њега. Наше особље сервиса вам је на располагању за савете у вези употребе производа, кваровима и могућностима поправке истог.',
  },
  areYouSureEmptyShoppingCart: 'Да ли сте сигурни да желите да испразните корпу?',
  discountCode: 'Код за попуст',
  remove: 'Уклони',
  yourCartIsEmpty: 'Ваша корпа је празна',
  vpPrice: 'ВП цена',
  howToRegisterText: 'Како се регистровати - Водич за коришћење',
  downloadOurApp: 'Преузмите нашу апликацију',
  mobileAppViewText: 'Уживајте у брзој и сигурној куповини уз најбоље попусте и нове производе!',
  bih: 'Босна и Херцеговина',
  jajce: 'Јајце',
  mostar: 'Мостар',
  sarajevo: 'Сарајево',
  banjaluka: 'Бања Лука',
  sirokiBrijeg: 'Широки Бријег',
  bihac: 'Бихаћ',
  kozarskaDubica: 'Козарска Дубица',
  teslic: 'Теслић',
  derventa: 'Дервента',
  forms: {
    notValid: 'Унети подаци нису валидни!',
    labels: {
      username: 'Корисничко име',
      abbreviation: 'Скраћеница',
      address: 'Адреса',
      email: 'Е-маил адреса',
      articleType: 'Врста артикла',
      availableValues: 'Доступне вредности',
      bank: 'Банка',
      bankAccount: 'Банковни рачун',
      brand: 'Бренд',
      catalogNumber: 'Каталошки број',
      category: 'Категорија',
      code: 'Шифра',
      company: 'Компанија',
      content: 'Садржај',
      country: 'Држава',
      countryName: 'Назив државе',
      defaultPrice: 'Подразумевана цена',
      description: 'Опис',
      fax: 'Факс',
      interestsArea: 'Делатност',
      isVisibleOnWeb: 'Видљиво на вебу',
      mpc: 'Малопродајна цена',
      name: 'Назив',
      nc: 'Набавна цена',
      nettoWeight: 'Нето тежина',
      officeNumber: 'Број канцеларије',
      phone: 'Телефон',
      password: 'Лозинка',
      confirmPassword: 'Потврди лозинку',
      shortDescription: 'Кратак опис',
      symbol: 'Симбол',
      taxGroup: 'Пореска група',
      title: 'Назив',
      town: 'Град',
      townName: 'Назив града',
      unit: 'Јединица',
      unitOfMeasure: 'Јединица мере',
      videoUrl: 'Видео линк',
      vpc: 'Велепродајна цена',
      firstName: 'Име',
      lastName: 'Презиме',
    },
    errors: {
      default: 'Догодила се грешка приликом валидације.',
      email: 'Поље {field} није валидна е-маил адреса.',
      integer: 'Поље {field} мора бити број.',
      minLength: 'Минимално {count} карактера.',
      required: 'Поље {field} је обавезно.',
      sameAs: 'Поље {field} и поље {field2} се не поклапају.',
      url: 'Поље {field} није валидан url.',
    },
  },
  tables: {
    email: 'Е-маил',
    firstLastName: 'Име и презиме',
    id: 'ID',
    name: 'Назив',
    phone: 'Телефон',
    town: 'Град',
    username: 'Корисничко име',
  },
};
